import React from "react";
import { useSelector } from "react-redux";
import { Grid } from "@material-ui/core";

import SubProductCard from "../../components/SubProductCard";
import WizardLayout from "../../components/WizardLayout";
import WizardNavigation from "../../components/WizardNavigation";

export default function SubProduct() {
  const { insuranceProducts, insuranceSelected } = useSelector(
    ({ insurances }) => ({
      insuranceSelected: insurances.selected,
      insuranceProducts:
        insurances.selected && insurances.selected.insuranceCompany.products
    })
  );

  const productsLocalInfo = insuranceSelected.subProducts;

  return (
    <WizardLayout activeStep={0} withNavigation={false} showNextButton={false}>
      <Grid
        container
        item
        xs={12}
        lg={10}
        spacing={2}
        justify="center"
        style={{ marginTop: 24 }}
      >
        {insuranceProducts.map((product, key) => {
          const productInfo = productsLocalInfo[product.productId] || {};
          return (
            <Grid key={key} item xs={5} sm={4}>
              <SubProductCard
                key={key}
                product={product}
                insurance={insuranceSelected}
                productLocalInfo={productInfo}
              />
            </Grid>
          );
        })}
      </Grid>
      <WizardNavigation next={false} />
    </WizardLayout>
  );
}
